/* eslint-disable global-require */
import React from 'react';
import { BREAKPOINT } from '@latitude/core/utils/constants';
import { MicrositeHeader } from '@latitude/microsite-header-rebrand';

const APPLY_NOW_URL =
  'https://cards.latitudefinancial.com/28degrees?promo_code=E8Q4CJE6&source_code=IDAAA';

function DegreesCardMicrositeHeader({ applyNowUrl = APPLY_NOW_URL, data }) {
  const navItems = data?.navItems || [
    {
      id: 'home',
      label: 'Home',
      trackId: 'nav-home',
      href: '/credit-cards/28-degrees/'
    },
    {
      id: 'travel-inspiration',
      label: 'Travel Inspiration',
      trackId: 'nav-travel-inspiration',
      href: '/credit-cards/28-degrees/travel-inspiration/'
    },
    {
      id: 'balance-transfer',
      label: 'Balance Transfer',
      trackId: 'nav-balance-transfer',
      href: '/credit-cards/balance-transfer/'
    },
    {
      id: 'faqs',
      label: 'FAQs',
      trackId: 'nav-faqs',
      href: '/credit-cards/28-degrees/faqs/'
    },
    {
      id: 'help',
      label: 'Help',
      trackId: 'help',
      href: 'https://latitudefs.zendesk.com/hc/en-au/'
    }
  ];

  return (
    <div
      css={`
         .microsite-header__nav-wrap {
          @media (min-width:1600px) {
            max-width: 1400px !important;
          }
        }
        .microsite-header__nav-wrap > *:first-child p {
          @media (min-width: ${BREAKPOINT.MD}) {
            margin-left: 5px !important;
          }
        }
        .microsite-header__inner {
          position: absolute;
          width: 100%;
          top: 56px;
          @media (min-width: ${BREAKPOINT.LG}) {
            top: 80px;
          }
        }
       .microsite-header__nav-wrap > div:first-of-type > p {
          @media (min-width: ${BREAKPOINT.LG}) {
            width: 202px;
          }
        }
        .microsite-header-rebrand {
          z-index: 2000 !important;
        }
        .top-menu-item__label a {
          @media (max-width: ${BREAKPOINT.LG}) {
            border-bottom: none;
          }
        }
      `}
    >
      <MicrositeHeader
        contentfulID={data?.id}
        data={navItems}
        ctaHref={data?.cta?.url || applyNowUrl}
        trademark={data?.trademark !== false}
        microSiteName={data?.navTitle || '28° Global'}
        target="_self"
      />
    </div>
  );
}

export default DegreesCardMicrositeHeader;
